import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';

import { useSalesSiteLeads } from '@/data/salessiteLead';

import SalesSiteList from './list/SalessiteList';

const ListPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Sales Site Leads
        </CardTitle>
        <CardDescription>Leads from the sales site.</CardDescription>
      </CardHeader>
      <CardContent>
        <SalesSiteList />
      </CardContent>
    </Card>
  );
};

const ListPageLoader = () => {
  const salesSiteLeads = useSalesSiteLeads();

  if (salesSiteLeads.isLoading && !salesSiteLeads.data) {
    return <LoadingPage />;
  }

  return <ListPage />;
};

export default ListPageLoader;
